import * as accountService from '/source/js/services/accountService';

var sessionTimeoutInterval = window.loginTimeout || 1800; // Default to 30 minutes when no value is provided by the server.
var sessionExpiredRedirectUrl = window.sessionExpiredRedirectUrl || '/sessionexpired';

$(function() {
    if(window.location.href.toLowerCase().indexOf(sessionExpiredRedirectUrl.toLowerCase()) > -1) {
        return;
    }

    let isAuthenticatedUser = accountService.isAuthenticatedUser();
    if(!isAuthenticatedUser) {
        return;
    }

    let timeoutInterval = sessionTimeoutInterval * 1000;
    setTimeout(clearSession, timeoutInterval);
});

function clearSession() {
    accountService.signOutMember(clearSessionComplete);
}

function clearSessionComplete(result) {
    window.location = sessionExpiredRedirectUrl;
}
